import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, FormControl, FormLabel, Input, Button, Box, Text, Flex, Checkbox, } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { ICountryDropDown } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import { CustomToast } from '../../../../components';

interface DocumentNameProps {
    isOpen: boolean;
    onClose: () => void;
    selectedCategory: { id: number; document_Category_Name: string } | null;
    editData?: any;
    isEditMode?: boolean;
    afterSave?: () => void;
}

export default function DocumentName({ isOpen, onClose, selectedCategory, editData, isEditMode, afterSave }: DocumentNameProps) {
    const [country, setCountry] = useState<ICountryDropDown[]>([]);
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [showDropdown, setShowDropdown] = useState(false);

    const [formData, setFormData] = useState({
        Document_Name_Title: '',
        Country: null as number | null,
        country_Name: '',
        expire: false,
        document_Number: false,
        is_Required: false,
        status: true

    });

    useEffect(() => {
        if (isOpen) {
            if (isEditMode && editData) {
                setFormData({
                    Document_Name_Title: editData.document_Name_Title,
                    Country: editData.country,
                    country_Name: editData.country === 0 ? "All Country" : editData.country_Name,
                    expire: editData.expire,
                    document_Number: editData.document_Number,
                    is_Required: editData.is_Required,
                    status: editData.status
                });


            } else {
                setFormData({
                    Document_Name_Title: '',
                    Country: null,
                    country_Name: '',
                    expire: false,
                    document_Number: false,
                    is_Required: false,
                    status: true
                });
            }
        }
    }, [isOpen, editData, isEditMode]);

    const loadCountry = async (filter: string | null) => {
        const response = await fetchApi<any[]>("Dropdown/country", "GET", null, `filter=${filter}`, "");
        if (response) {
            setShowDropdown(true);
            const allOption: ICountryDropDown = {
                id: 0,
                country_Name: "All Country"
            };
            setCountry([allOption, ...response]);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleCountryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFormData(prev => ({...prev,country_Name: value,Country: null}));
        if (value.length >= 2) {loadCountry(value);} else {setCountry([]);setShowDropdown(false);}
    };

    const handleCountrySelect = (name: string, id: number) => {
        setFormData(prev => ({...prev,country_Name: name,Country: id}));
        setShowDropdown(false);
    };

    const handleSubmit = async () => {
        if (!formData.Document_Name_Title) {
            addToast({ message: "Please enter document name", status: "error" });
            return;
        }
        const categoryId = isEditMode ? editData?.document_Category_Id : selectedCategory?.id;
        if (!categoryId) {
            addToast({ message: "Category missing", status: "error" });
            return;
        }
        const payload = {...formData,Document_Category_Id: categoryId,id: editData?.id};
        let response;
        if (isEditMode) {
            response = await fetchApi(
                "Hrlense_Document_Category/updatedocument","PUT",payload,null,"Document updated successfully");
        } else {
            response = await fetchApi(
                "Hrlense_Document_Category/postdocument","POST",payload,null,"Document added successfully");
        }
        if (response) {
            onClose();
            afterSave?.();
        }
    };
    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>
                    Add Document to:{" "}
                    <Text as="span" fontWeight="semibold">
                        {selectedCategory?.document_Category_Name}
                    </Text>
                </DrawerHeader>

                <DrawerBody>
                    <FormControl mb={4} position="relative">
                        <FormLabel>Country</FormLabel>
                        <Input placeholder="Type to search..." value={formData.country_Name} onChange={handleCountryChange} />
                        {showDropdown && country.length > 0 && (
                            <Box position="absolute" top="60px" left="0" right="0" bg="white" border="1px solid #E2E8F0" borderRadius="md" maxH="150px" overflowY="auto" zIndex={20}>
                                {country.map((c) => (
                                    <Box key={c.id} px={4} py={2} _hover={{ backgroundColor: "gray.100", cursor: "pointer" }} bg={formData.Country === c.id ? "blue.100" : "white"} onClick={() => handleCountrySelect(c.country_Name ?? "", c.id)} >
                                        {c.country_Name}
                                    </Box>
                                ))}
                            </Box>
                        )}

                        {showDropdown && country.length === 0 && (
                            <Box position="absolute" top="60px" left="0" right="0" bg="white" border="1px solid #E2E8F0" borderRadius="md" zIndex={20} px={4} py={2} color="gray.500" >
                                No countries found
                            </Box>
                        )}
                    </FormControl>

                    <FormControl mb={4}>
                        <FormLabel>Document Name</FormLabel>
                        <Input name="Document_Name_Title" placeholder="Enter document name" value={formData.Document_Name_Title} onChange={handleInputChange} />
                    </FormControl>

                    <FormControl mb={4}>
                        <Checkbox name="expire" isChecked={formData.expire} onChange={handleInputChange} >
                            Expired
                        </Checkbox>
                    </FormControl>
                    <FormControl mb={4}>
                        <Checkbox name="document_Number" isChecked={formData.document_Number} onChange={handleInputChange} >
                            Document Number
                        </Checkbox>
                    </FormControl>
                    <FormControl mb={4}>
                        <Checkbox name="is_Required" isChecked={formData.is_Required} onChange={handleInputChange} >
                            Is Required
                        </Checkbox>
                    </FormControl>

                    <FormControl mb={4}>
                        <Checkbox name="status" isChecked={formData.status} onChange={handleInputChange} >
                            Active
                        </Checkbox>
                    </FormControl>

                    {/* Buttons */}
                    <Flex justify="flex-end" mt={4}>
                        <Button onClick={onClose} colorScheme="red" mr={3}>
                            Cancel
                        </Button>
                        <Button colorScheme="green" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Flex>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
}
